import { protectedResources } from "../config/authConfig";
import { InventoryData, Product, PlanTypes } from "../types/inventoryData";
import { _fetch, getToken } from "./apiHelper";

export const GetAllProducts = async () => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
  };

  return _fetch(protectedResources.api.inventory, options);
};

export const UpdateProduct = async (obj: InventoryData) => {
  // if(obj.updatedProduct.location) obj.updatedProduct.location = obj.updatedProduct.location?.trim();
  // if(obj.updatedProduct.note) obj.updatedProduct.note = obj.updatedProduct.note?.trim();
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "PATCH",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(obj),
  };

  return _fetch(
    protectedResources.api.inventory,
    options
  );
};

export const BatchEditProducts = async (obj: InventoryData[]) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "PATCH",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(obj),
  };

  return _fetch(
    protectedResources.api.inventory + `/batch`,
    options
  );
}

export const AddProduct = async (product: Product) => {
  if(product.location) product.location = product.location?.trim();
  if(product.note) product.note = product.note?.trim();
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "POST",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(product),
  };

  return _fetch(protectedResources.api.inventory, options);
};

export const GetAllHistoriesFromProduct = async (productId: number) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
  };

  return _fetch(
    protectedResources.api.productHistory + `/${productId}`,
    options
  );
};

export const GetAllInventoryPlans = async () => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
  };

  return _fetch(protectedResources.api.inventory + "/plans", options);
};

export const AddInventoryPlan = async (plan: PlanTypes) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "POST",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(plan),
  };

  return _fetch(protectedResources.api.inventory + "/plans", options);
};

export const UpdateInventoryPlan = async (plan: PlanTypes) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "PATCH",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(plan),
  };

  return _fetch(protectedResources.api.inventory + "/plans", options);
};

export const GetAllProductTypes = async () => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
  };

  return _fetch(protectedResources.api.inventory + "/productTypes", options);
};

export const DeleteInventoryPlan = async (body: PlanTypes) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "DELETE",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(body)
  };

  return _fetch(protectedResources.api.inventory + "/plans", options);
};

export const DeleteInventoryProduct = async (productId: number) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "DELETE",
    headers: headers,
    cache: "no-cache" as RequestCache,
  };

  return _fetch(protectedResources.api.inventory + `/${productId}`, options);
};